import { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import General from "services/GeneralEndpoints"
import PlasticsApplication from "services/PlasticsApplication.service"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)
const plasticsApp = new PlasticsApplication(user)

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES
const REQUIRED_DOC = STATIC_FILES + "/files/Export-import-English-Basel-Convention.docx"

const Documents = props => {
  const [serviceAttachments, setserviceAttachments] = useState()

  useEffect(() => {
    fetchAttachments(props.service_id)
  }, [props.service_id])

  const download = (path, name) => {
    plasticsApp
      .downloadAttachment(path)
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  const fetchAttachments = service_id => {
    generalService.getServiceAttachments(service_id).then(response => {
      if (response.status) {
        const attachments = response.data.map((attachment, index) => (
          <tr key={index}>
            <td>{attachment.description}</td>
            <td>
              <input
                className="form-control btn-info"
                type="file"
                id={attachment.name}
                required={attachment.is_mandatory}
                accept=".doc,.docx,.pdf,image/*"
              />
            </td>
          </tr>
        ))
        setserviceAttachments(attachments)
      }
    })
  }
  return (
    <>
      {props.service_id === "4" || props.service_id === 4 ? (
        <Card>
          <CardHeader className="alert alert-info">Signed Notification by the two countries</CardHeader>
          <CardBody>
            Signed Notification from the country of export and country of import Template
            <br></br>
            Download, fill and, upload the signed notification by the two countries
            <br></br>
            <br></br>
            <a href={REQUIRED_DOC} target={"_blank"} >Click to download signed notifications Document</a>
          </CardBody>
        </Card>
      ) : null}

      <table className="table table-responsive table-striped">
        <tbody>{serviceAttachments}</tbody>
      </table>
    </>
  )
}

export default Documents
